import AccountStateReasonCode from "@/models/Accounts/Shared/AccountStateReasonCode";

export default (val: AccountStateReasonCode) => {
    let returnVal = "Undefined";
    switch (val) {
        case AccountStateReasonCode.Inactive:
            returnVal = "Inactive"
            break;
        case AccountStateReasonCode.Manual:
            returnVal = "Manual"
            break;
        case AccountStateReasonCode.CassSwitch:
            returnVal = "CASS Switch"
            break;
        case AccountStateReasonCode.FtdMatured:
            returnVal = "FTD Matured"
            break;
        case AccountStateReasonCode.FtdUnderfunded:
            returnVal = "FTD Underfunded"
            break;
        case AccountStateReasonCode.EarlyBreakage:
            returnVal = "Early Breakage"
            break;
    }
    return returnVal;
}